import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

/**
 * Shown to a realtor account on a deployment where the property-listings
 * vertical is switched off. Existing realtor sign-ups must land somewhere that
 * explains itself rather than on an empty shell of dead menu items.
 */
export default function RealtorNotAvailablePage({ tools = 'Estate agent tools' }) {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 2, color: 'text.secondary' }}>
          <HomeWorkIcon sx={{ fontSize: 48 }} />
        </Box>
        <Typography variant="h5" gutterBottom>
          Not available yet
        </Typography>
        <Typography color="text.secondary">
          {tools} are not available on Eqaya yet. We will email you when they open.
        </Typography>
      </Paper>
    </Container>
  );
}
